import { removeUrlPatterns } from '@/common/utils/remove-url-patterns'

/**
 * view more quick push router
 * @param url
 * @returns {{path: string}} // router object
 */
export const navigateViewMoreQuickPush = (url) => {
  console.log('navigateViewMoreQuickPush', url)
  const removePatterns = [
    'captvpooq://',
    'http://',
    'https://',
    'www.wavve.com',
    '.html',
  ]

  return {
    path: removeUrlPatterns(url, removePatterns),
  }
}
